import React from 'react';
import GoogleMapComponent from '../components/GoogleMapComponent';
import CardWe from '../components/CardWe';
import AboutClinic from '../components/AboutClinic';
import WhatsappFloatButton from '../components/WhatsappFloatButton';
import StyleNosotros from './Nosotros.module.css';

function Nosotros() {
    return (
        <>
            <div className={StyleNosotros.fondo}>
                <AboutClinic />
                < CardWe />
                <WhatsappFloatButton />
                <GoogleMapComponent />
            </div>
        </>

    );
}

export default Nosotros;
